import React from 'react';
import { Link } from 'react-router-dom';

type LogoSize = 'sm' | 'md' | 'lg';

const dimensions: Record<LogoSize, { icon: number; text: number }> = {
  sm: { icon: 28, text: 16 },
  md: { icon: 36, text: 22 },
  lg: { icon: 48, text: 28 },
};

function LogoIcon({ size }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M8 14 L20 24 L8 34"
        stroke="#0064E0"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="26" y="26" width="16" height="14" rx="3" fill="#0064E0" />
      <path
        d="M29 26 L29 21 Q34 16 39 21 L39 26"
        stroke="#0064E0"
        strokeWidth="3"
        strokeLinecap="round"
        fill="none"
      />
      <circle cx="34" cy="32" r="2" fill="white" />
      <rect x="33" y="33" width="2" height="4" fill="white" />
    </svg>
  );
}

type LogoProps = {
  size?: LogoSize;
  className?: string;
};

export function Logo({ size = 'md', className = '' }: LogoProps) {
  const { icon, text } = dimensions[size];
  return (
    <Link
      to="/"
      className={`inline-flex items-center gap-2.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0064E0] focus-visible:ring-offset-2 rounded-md ${className}`}
    >
      <LogoIcon size={icon} />
      <span
        className="font-normal text-[#1C1E21] leading-none"
        style={{ fontSize: text }}
      >
        log<strong className="font-bold text-[#0064E0]">N</strong>sec
      </span>
    </Link>
  );
}
